import { basePermissionManagerApi as api } from '../basePermissionManagerApi';
export const addTagTypes = ['ResourceType'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getResourceTypes: build.query<
        GetResourceTypesApiResponse,
        GetResourceTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/resourceTypes`,
          params: {
            namespaces: queryArg.namespaces,
          },
        }),
        providesTags: ['ResourceType'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseGeneratedApi };
export type GetResourceTypesApiResponse = unknown;
export type GetResourceTypesApiArg = {
  namespaces?: string[];
};
export const { useGetResourceTypesQuery } = injectedRtkApi;
